import { FjellsportMapWrapper } from 'components/eventView/pages/MapWrappers/FjellsportMapWrapper';
import { MartinMapWrapper } from 'components/eventView/pages/MapWrappers/MartinMapWrapper';
import { NorboatMapWrapper } from 'components/eventView/pages/MapWrappers/NorboatMapWrapper';
import { Terrain3dMapWrapper } from 'components/eventView/pages/MapWrappers/Terrain3dMapWrapper';
import { CustomMapPage, CustomMapPageProps } from 'pages/custom/shared/CustomMapPage';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';

export const MapWrapper = (props: CustomMapPageProps) => {
    const eventData = useContext(CtxEventView).eventData;

    if (eventData.mapWrapper === 'fjellsport') {
        return <FjellsportMapWrapper {...props} />;
    }

    //martin
    else if (eventData.eventId === '9a8d0e6c-51ad-4018-ade0-202539880a10') {
        return <MartinMapWrapper {...props} />;
    }

    //trondelag
    else if (eventData.eventId === 'a6d69a7b-bb54-4ec7-b08e-c73ac9c57979') {
        return <Terrain3dMapWrapper {...props} />;
    }

    //ms
    else if (eventData.eventId === 'cycling') {
        return <Terrain3dMapWrapper {...props} />;
    }

    if (eventData.eventId === 'bater2024') {
        return <NorboatMapWrapper {...props} />;
    }

    return <CustomMapPage {...props} />;
};
